import { Box } from '../Box'

import type { TableCellProps } from './types'

export const Cell = ({ isHeader, ...props }: TableCellProps) => (
  <Box as={isHeader ? 'th' : 'td'} {...props} />
)
